import React from 'react';
import Retailer from './Retailer';
import retailerData from './retailerData.json';

const BuyingSites = ({ region }) => {
	const retailers = retailerData.map((retailer,index) => {
		let html;
		if (retailer.region === region) {
			html = <Retailer key={ index } retailer={ retailer } />;
		}
		return html;
	});
	return (
		<ul className="retailers-list">
			{ retailers }
		</ul>
	);
};

export default BuyingSites;


// WEBPACK FOOTER //
// ./src/pages/whereToBuy/BuyingSites.js